import { XIcon } from 'lucide-react';

import styles from './service-creation-perk-item.module.scss';

type Props = {
    id: number;
    text: string;
    onDelete: (id: number) => void;
};

const ServiceCreationPerkItem = ({ id, text, onDelete }: Props) => (
    <div className={styles.perk}>
        <span>{text}</span>
        <div className={styles.icon} onClick={() => onDelete(id)}>
            <XIcon size={16} />
        </div>
    </div>
);

export { ServiceCreationPerkItem };
